import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appCodePromo]'
})
export class CodePromoDirective {

  @Input('typeDirective') tipo: any;
  public regex: RegExp = new RegExp(/^[a-zA-Z0-9]+$/);
  constructor(private el: ElementRef, private control: NgControl) {}
  @HostListener('input', ['$event'])
  onInput(event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
    input.value = input.value.replace(/[^a-zA-Z0-9]/g, '');
    this.control.control.patchValue(input.value);
  }

  @HostListener('blur', ['$event'])
  onblur(event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.trim();
    this.control.control.patchValue(input.value);
  }

}
